export default (obj, path='', fallback) => path.length ? (path.split('.').reduce((acc, part) => acc && acc[part], obj) || fallback) : obj;



// WEBPACK FOOTER //
// ./src/utils/get.js